
// @ts-nocheck


export const localeCodes =  [
  "en",
  "ru",
  "tr",
  "de",
  "fr",
  "es",
  "xx",
  "ar",
  "zh",
  "ta",
  "vi",
  "kk",
  "it",
  "nl",
  "he",
  "ko",
  "pt",
  "th",
  "uk",
  "pl",
  "ro",
  "hi"
]

export const localeLoaders = {
  "en": [{ key: "../i18n/locales/en-US.json", load: () => import("../i18n/locales/en-US.json" /* webpackChunkName: "locale__usr_src_app_packages_all_inclusive_app_i18n_locales_en_US_json" */), cache: true }],
  "ru": [{ key: "../i18n/locales/en-US.json", load: () => import("../i18n/locales/en-US.json" /* webpackChunkName: "locale__usr_src_app_packages_all_inclusive_app_i18n_locales_en_US_json" */), cache: true }],
  "tr": [{ key: "../i18n/locales/en-US.json", load: () => import("../i18n/locales/en-US.json" /* webpackChunkName: "locale__usr_src_app_packages_all_inclusive_app_i18n_locales_en_US_json" */), cache: true }],
  "de": [{ key: "../i18n/locales/en-US.json", load: () => import("../i18n/locales/en-US.json" /* webpackChunkName: "locale__usr_src_app_packages_all_inclusive_app_i18n_locales_en_US_json" */), cache: true }],
  "fr": [{ key: "../i18n/locales/en-US.json", load: () => import("../i18n/locales/en-US.json" /* webpackChunkName: "locale__usr_src_app_packages_all_inclusive_app_i18n_locales_en_US_json" */), cache: true }],
  "es": [{ key: "../i18n/locales/en-US.json", load: () => import("../i18n/locales/en-US.json" /* webpackChunkName: "locale__usr_src_app_packages_all_inclusive_app_i18n_locales_en_US_json" */), cache: true }],
  "xx": [{ key: "../i18n/locales/en-US.json", load: () => import("../i18n/locales/en-US.json" /* webpackChunkName: "locale__usr_src_app_packages_all_inclusive_app_i18n_locales_en_US_json" */), cache: true }],
  "ar": [{ key: "../i18n/locales/en-US.json", load: () => import("../i18n/locales/en-US.json" /* webpackChunkName: "locale__usr_src_app_packages_all_inclusive_app_i18n_locales_en_US_json" */), cache: true }],
  "zh": [{ key: "../i18n/locales/en-US.json", load: () => import("../i18n/locales/en-US.json" /* webpackChunkName: "locale__usr_src_app_packages_all_inclusive_app_i18n_locales_en_US_json" */), cache: true }],
  "ta": [{ key: "../i18n/locales/en-US.json", load: () => import("../i18n/locales/en-US.json" /* webpackChunkName: "locale__usr_src_app_packages_all_inclusive_app_i18n_locales_en_US_json" */), cache: true }],
  "vi": [{ key: "../i18n/locales/en-US.json", load: () => import("../i18n/locales/en-US.json" /* webpackChunkName: "locale__usr_src_app_packages_all_inclusive_app_i18n_locales_en_US_json" */), cache: true }],
  "kk": [{ key: "../i18n/locales/en-US.json", load: () => import("../i18n/locales/en-US.json" /* webpackChunkName: "locale__usr_src_app_packages_all_inclusive_app_i18n_locales_en_US_json" */), cache: true }],
  "it": [{ key: "../i18n/locales/en-US.json", load: () => import("../i18n/locales/en-US.json" /* webpackChunkName: "locale__usr_src_app_packages_all_inclusive_app_i18n_locales_en_US_json" */), cache: true }],
  "nl": [{ key: "../i18n/locales/en-US.json", load: () => import("../i18n/locales/en-US.json" /* webpackChunkName: "locale__usr_src_app_packages_all_inclusive_app_i18n_locales_en_US_json" */), cache: true }],
  "he": [{ key: "../i18n/locales/en-US.json", load: () => import("../i18n/locales/en-US.json" /* webpackChunkName: "locale__usr_src_app_packages_all_inclusive_app_i18n_locales_en_US_json" */), cache: true }],
  "ko": [{ key: "../i18n/locales/en-US.json", load: () => import("../i18n/locales/en-US.json" /* webpackChunkName: "locale__usr_src_app_packages_all_inclusive_app_i18n_locales_en_US_json" */), cache: true }],
  "pt": [{ key: "../i18n/locales/en-US.json", load: () => import("../i18n/locales/en-US.json" /* webpackChunkName: "locale__usr_src_app_packages_all_inclusive_app_i18n_locales_en_US_json" */), cache: true }],
  "th": [{ key: "../i18n/locales/en-US.json", load: () => import("../i18n/locales/en-US.json" /* webpackChunkName: "locale__usr_src_app_packages_all_inclusive_app_i18n_locales_en_US_json" */), cache: true }],
  "uk": [{ key: "../i18n/locales/en-US.json", load: () => import("../i18n/locales/en-US.json" /* webpackChunkName: "locale__usr_src_app_packages_all_inclusive_app_i18n_locales_en_US_json" */), cache: true }],
  "pl": [{ key: "../i18n/locales/en-US.json", load: () => import("../i18n/locales/en-US.json" /* webpackChunkName: "locale__usr_src_app_packages_all_inclusive_app_i18n_locales_en_US_json" */), cache: true }],
  "ro": [{ key: "../i18n/locales/en-US.json", load: () => import("../i18n/locales/en-US.json" /* webpackChunkName: "locale__usr_src_app_packages_all_inclusive_app_i18n_locales_en_US_json" */), cache: true }],
  "hi": [{ key: "../i18n/locales/en-US.json", load: () => import("../i18n/locales/en-US.json" /* webpackChunkName: "locale__usr_src_app_packages_all_inclusive_app_i18n_locales_en_US_json" */), cache: true }]
}

export const vueI18nConfigs = [
  () => import("../i18n.config.ts?hash=bffaebcb&config=1" /* webpackChunkName: "i18n_config_bffaebcb" */)
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": false,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "dir": "ltr",
      "name": "English",
      "language": "en-US",
      "files": [
        "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      ]
    },
    {
      "code": "ru",
      "dir": "ltr",
      "name": "Russian",
      "language": "ru-RU",
      "files": [
        "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      ]
    },
    {
      "code": "tr",
      "dir": "ltr",
      "name": "Turc",
      "language": "tr-TR",
      "files": [
        "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      ]
    },
    {
      "code": "de",
      "dir": "ltr",
      "name": "German",
      "language": "de-DE",
      "files": [
        "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      ]
    },
    {
      "code": "fr",
      "dir": "ltr",
      "name": "Français",
      "language": "fr-FR",
      "files": [
        "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      ]
    },
    {
      "code": "es",
      "dir": "ltr",
      "name": "Spanish",
      "language": "es-ES",
      "files": [
        "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      ]
    },
    {
      "code": "xx",
      "dir": "ltr",
      "name": "Translations",
      "language": "xx-XX",
      "files": [
        "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      ]
    },
    {
      "code": "ar",
      "dir": "rtl",
      "name": "Arabic",
      "language": "ar-AE",
      "files": [
        "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      ]
    },
    {
      "code": "zh",
      "dir": "rtl",
      "name": "Chinese",
      "language": "zh-CN",
      "files": [
        "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      ]
    },
    {
      "code": "ta",
      "dir": "ltr",
      "name": "Tamil",
      "language": "ta-IN",
      "files": [
        "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      ]
    },
    {
      "code": "vi",
      "dir": "ltr",
      "name": "Vietnamese",
      "language": "vi-VN",
      "files": [
        "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      ]
    },
    {
      "code": "kk",
      "dir": "ltr",
      "name": "Kazakh",
      "language": "kk-KZ",
      "files": [
        "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      ]
    },
    {
      "code": "it",
      "dir": "ltr",
      "name": "Italian",
      "language": "it-IT",
      "files": [
        "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      ]
    },
    {
      "code": "nl",
      "dir": "ltr",
      "name": "Dutch",
      "language": "nl-NL",
      "files": [
        "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      ]
    },
    {
      "code": "he",
      "dir": "rtl",
      "name": "Hebrew",
      "language": "he-IL",
      "files": [
        "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      ]
    },
    {
      "code": "ko",
      "dir": "ltr",
      "name": "Korean",
      "language": "ko-KR",
      "files": [
        "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      ]
    },
    {
      "code": "pt",
      "dir": "ltr",
      "name": "Portuguese",
      "language": "pt-PT",
      "files": [
        "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      ]
    },
    {
      "code": "th",
      "dir": "ltr",
      "name": "Thai",
      "language": "th-TH",
      "files": [
        "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      ]
    },
    {
      "code": "uk",
      "dir": "ltr",
      "name": "Ukrainian",
      "language": "uk-UA",
      "files": [
        "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      ]
    },
    {
      "code": "pl",
      "dir": "ltr",
      "name": "Polish",
      "language": "pl-PL",
      "files": [
        "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      ]
    },
    {
      "code": "ro",
      "dir": "ltr",
      "name": "Romanian",
      "language": "ro-RO",
      "files": [
        "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      ]
    },
    {
      "code": "hi",
      "dir": "ltr",
      "name": "Hindi",
      "language": "hi-IN",
      "files": [
        "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": true,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_and_default",
  "lazy": true,
  "langDir": "./i18n/locales",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "multiDomainLocales": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "dir": "ltr",
    "name": "English",
    "language": "en-US",
    "files": [
      {
        "path": "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      }
    ]
  },
  {
    "code": "ru",
    "dir": "ltr",
    "name": "Russian",
    "language": "ru-RU",
    "files": [
      {
        "path": "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      }
    ]
  },
  {
    "code": "tr",
    "dir": "ltr",
    "name": "Turc",
    "language": "tr-TR",
    "files": [
      {
        "path": "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      }
    ]
  },
  {
    "code": "de",
    "dir": "ltr",
    "name": "German",
    "language": "de-DE",
    "files": [
      {
        "path": "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      }
    ]
  },
  {
    "code": "fr",
    "dir": "ltr",
    "name": "Français",
    "language": "fr-FR",
    "files": [
      {
        "path": "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      }
    ]
  },
  {
    "code": "es",
    "dir": "ltr",
    "name": "Spanish",
    "language": "es-ES",
    "files": [
      {
        "path": "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      }
    ]
  },
  {
    "code": "xx",
    "dir": "ltr",
    "name": "Translations",
    "language": "xx-XX",
    "files": [
      {
        "path": "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      }
    ]
  },
  {
    "code": "ar",
    "dir": "rtl",
    "name": "Arabic",
    "language": "ar-AE",
    "files": [
      {
        "path": "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      }
    ]
  },
  {
    "code": "zh",
    "dir": "rtl",
    "name": "Chinese",
    "language": "zh-CN",
    "files": [
      {
        "path": "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      }
    ]
  },
  {
    "code": "ta",
    "dir": "ltr",
    "name": "Tamil",
    "language": "ta-IN",
    "files": [
      {
        "path": "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      }
    ]
  },
  {
    "code": "vi",
    "dir": "ltr",
    "name": "Vietnamese",
    "language": "vi-VN",
    "files": [
      {
        "path": "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      }
    ]
  },
  {
    "code": "kk",
    "dir": "ltr",
    "name": "Kazakh",
    "language": "kk-KZ",
    "files": [
      {
        "path": "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      }
    ]
  },
  {
    "code": "it",
    "dir": "ltr",
    "name": "Italian",
    "language": "it-IT",
    "files": [
      {
        "path": "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      }
    ]
  },
  {
    "code": "nl",
    "dir": "ltr",
    "name": "Dutch",
    "language": "nl-NL",
    "files": [
      {
        "path": "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      }
    ]
  },
  {
    "code": "he",
    "dir": "rtl",
    "name": "Hebrew",
    "language": "he-IL",
    "files": [
      {
        "path": "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      }
    ]
  },
  {
    "code": "ko",
    "dir": "ltr",
    "name": "Korean",
    "language": "ko-KR",
    "files": [
      {
        "path": "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      }
    ]
  },
  {
    "code": "pt",
    "dir": "ltr",
    "name": "Portuguese",
    "language": "pt-PT",
    "files": [
      {
        "path": "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      }
    ]
  },
  {
    "code": "th",
    "dir": "ltr",
    "name": "Thai",
    "language": "th-TH",
    "files": [
      {
        "path": "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      }
    ]
  },
  {
    "code": "uk",
    "dir": "ltr",
    "name": "Ukrainian",
    "language": "uk-UA",
    "files": [
      {
        "path": "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      }
    ]
  },
  {
    "code": "pl",
    "dir": "ltr",
    "name": "Polish",
    "language": "pl-PL",
    "files": [
      {
        "path": "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      }
    ]
  },
  {
    "code": "ro",
    "dir": "ltr",
    "name": "Romanian",
    "language": "ro-RO",
    "files": [
      {
        "path": "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      }
    ]
  },
  {
    "code": "hi",
    "dir": "ltr",
    "name": "Hindi",
    "language": "hi-IN",
    "files": [
      {
        "path": "/usr/src/app/packages/all-inclusive-app/i18n/locales/en-US.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
